import BaseLayout from './landing/components/BaseLayout';
import { Route, HashRouter as Router, Routes } from 'react-router-dom';
import Constitution from './pages/constitution/Constitution';
import Journals from './pages/journals/Journals';
import Books from './pages/books/Books';
import Cases from './pages/cases/Cases';
import RegionalCases from './pages/regionalCases/RegionalCases';
import Cuttings from './pages/cuttings/Cuttings';
import Videos from './pages/videos/Videos';
import Audios from './pages/audios/Audios';
import Home from './pages/home/Home';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Faq from './pages/faq/Faq';
import Privacy from './pages/privacy/Privacy';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/pageTransition/PageTransition';
import Dashboard from './pages/dashboard/Dashbaord';
import { ThemeProvider } from './context/ThemeProvider';
import Users from './pages/users/Users';
import TanzaniaConstitution from './pages/TanzaniaConstitution/TanzaniaConstitution';
import Constitutions from './pages/Constitutions/Contitutions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Upload from './pages/upload/Upload';
import Timeline from './pages/timeline/Timeline';
import Read from './pages/read/Read';
import MediaTypes from './pages/MediaTypes/MediaTypes';
import MaterialTypes from './pages/MaterialType/MaterialType';
import Roles from './pages/Roles/Roles';
import NotFound from './pages/NoFound/NotFound';
import Reports from './pages/reports/Reports';
import Other from './pages/other/Other';
import SearchResults from './pages/search/SearchResults';
function App() {
    return (
        <>
            <ThemeProvider>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme={() => {
                        const savedTheme = localStorage.getItem('theme');
                        return savedTheme || 'light';
                    }}
                />
                <Router>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Home />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/constitution"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Constitution />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/tanzania-constitution"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <TanzaniaConstitution />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/journals"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Journals />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/books"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Books />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/reports"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Reports />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/cases"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Cases />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/regional-cases"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <RegionalCases />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/cuttings"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Cuttings />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/audios"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Audios />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/videos"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Videos />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/other"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Other />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/search"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <SearchResults />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/login"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Login />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/videos"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Videos />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/register"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Register />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/faq"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Faq />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/privacy"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Privacy />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        {/* Administration protected routes */}
                        <Route
                            path="/dashboard"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Dashboard />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/users"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Users />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/constitutions"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Constitutions />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/upload"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Upload />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/timeline"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Timeline />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/read/:id"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Read />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/read"
                            element={
                                <BaseLayout isProtectedHeader={false}>
                                    <ScrollToTop />
                                    <PageTransition>
                                        <Read />
                                    </PageTransition>
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/media"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <MediaTypes />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/material"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <MaterialTypes />
                                </BaseLayout>
                            }
                        />
                        <Route
                            path="/roles"
                            element={
                                <BaseLayout isProtectedHeader={true}>
                                    <Roles />
                                </BaseLayout>
                            }
                        />

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </>
    );
}

export default App;
